/**
 * @generated SignedSource<<a3cde2ef6e92a8f54fc04bc8d66e09bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type dataFunnelsListQuery$variables = {
  ids: ReadonlyArray<number>;
};
export type dataFunnelsListQuery$data = {
  readonly funnelsList: ReadonlyArray<{
    readonly _id: number;
    readonly id: string;
    readonly label: string;
    readonly name: string;
  } | null>;
};
export type dataFunnelsListQuery = {
  variables: dataFunnelsListQuery$variables;
  response: dataFunnelsListQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
      }
    ],
    "concreteType": "Funnel",
    "kind": "LinkedField",
    "name": "funnelsList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": "label",
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dataFunnelsListQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dataFunnelsListQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "62bbefed612226884f76ef837e78fb10",
    "id": null,
    "metadata": {},
    "name": "dataFunnelsListQuery",
    "operationKind": "query",
    "text": "query dataFunnelsListQuery(\n  $ids: [Int!]!\n) {\n  funnelsList(ids: $ids) {\n    _id\n    id\n    label: name\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "b829f207d478c1833b83fd83bb0a3776";

export default node;
